<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <coverage-info></coverage-info>
    <material-card
      :title="$t('views.portalcoverage.coverage_content')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="perm_scan_wifi"
    >
      <v-card-text>
        {{ $t("views.portalcoverage.content_helptext") }}
      </v-card-text>
      <v-card>
        <v-card-title>
          {{ $t("views.portalcoverage.coverage_categories") }}
        </v-card-title>
        <v-card-text>
          <category-list
            ref="categories"
            @categories-changed="categories = $event"
            :items="items"
            @reload-items="$refs.items.reload()"
          ></category-list>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title>
          {{ $t("headers.coveragecategories.content_items") }}
        </v-card-title>
        <v-card-text>
          <item-list
            ref="items"
            :categories="categories"
            @items-changed="items = $event"
            @reload-categories="$refs.categories.reload()"
          ></item-list>
        </v-card-text>
      </v-card>
    </material-card>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import CoverageInfo from "../components/PortalCoverage/CoverageInfo";
import CategoryList from "../components/PortalCoverage/CategoryList";
import ItemList from "../components/PortalCoverage/ItemList";
import { planSetter } from "../mixins/planSetter";
import { mapGetters } from "vuex";
import { portalPermission } from "../mixins/portalPermission";

export default {
  components: {
    CoverageInfo,
    CategoryList,
    ItemList,
  },
  mixins: [planSetter, portalPermission],
  data() {
    return {
      items: [],
      categories: [],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" })
  },
};
</script>
